import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Paper, Typography, Link } from '@mui/material';
import { INK } from '../../utils/commercialColors';

export default function AgentPerformance({ agents }) {
  if (!agents) return null;

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Dashboard ambassadeurs
      </Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: `1px solid ${INK.gridline}` }}>
              {['Ambassadeur', 'Zone', 'Leads', 'Essais', 'Payants', 'Conversion', 'MRR généré'].map((h) => (
                <th key={h} style={{ padding: '8px 12px', color: INK.muted, fontWeight: 500 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {agents.map((a) => {
              const trials = Number(a.trials) || 0;
              const payants = Number(a.payants) || 0;
              const conversion = trials > 0 ? ((payants / trials) * 100).toFixed(0) : 0;
              return (
                <tr key={a.id} style={{ borderBottom: `1px solid ${INK.gridline}` }}>
                  <td style={{ padding: '8px 12px', fontWeight: 600 }}>
                    <Link component={RouterLink} to={`/admin/commercial/agent/${a.id}`} sx={{ color: INK.primary }}>
                      {a.first_name} {a.last_name}
                    </Link>
                  </td>
                  <td style={{ padding: '8px 12px' }}>{a.zone || '—'}</td>
                  <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{a.leads}</td>
                  <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{trials}</td>
                  <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{payants}</td>
                  <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>{conversion}%</td>
                  <td style={{ padding: '8px 12px', fontVariantNumeric: 'tabular-nums' }}>
                    {Number(a.mrr_generated).toLocaleString('fr-FR')} €
                  </td>
                </tr>
              );
            })}
            {agents.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 16, textAlign: 'center', color: INK.muted }}>Aucun ambassadeur</td></tr>
            )}
          </tbody>
        </table>
      </Box>
    </Paper>
  );
}
